import React, { useState } from "react";
import { Subscribe } from "unstated";
import StateContainer from "../../state/StateContainer";
import stringHelper from "../../utils/helpers/stringHelper";

import "./OrbViewButton.css";
import OrbViewScene from "../../utils/OrbViewScene";

function OrbViewButton(props) {
  const [isButtonHovered, setIsButtonHovered] = useState(false);
  const { image, id } = props;

  const backgroundColor = isButtonHovered
    ? stringHelper.removeAplhaFromColor(
        props.unstated.state.menuColorSecondary
      )
    : props.unstated.state.menuColor;

  function ShowScene() {
    props.unstated.handleShowElement("orbViewScene", true);
  }

  function ClickHandler() {
    OrbViewScene.changeSkyboxBackground(image, ShowScene);
  }

  return (
    <button
      className="orb-sidebar__button"
      onClick={ClickHandler}
      onMouseEnter={() => setIsButtonHovered(true)}
      onMouseLeave={() => setIsButtonHovered(false)}
      style={{ backgroundColor }}
    >
      {id}
    </button>
  );
}

function OrbViewButtonWithUnstated(props) {
  return (
    <Subscribe to={[StateContainer]}>
      {(unstated) => <OrbViewButton {...props} unstated={unstated} />}
    </Subscribe>
  );
}

export default OrbViewButtonWithUnstated;
